import services from '@/http'
import * as types from './mutations-types'

const ActionListing = ({ commit }, payload) => {

	return services.accessLocations.listing(payload).then(res => {
		let listing = JSON.parse(JSON.stringify(res.data.data));
		commit(types.SET_LISTING, listing);
	});

}

 const ActionRevoke = ({ commit }, accessLocation) => {
	return services.accessLocations.revoke({ cgi_id: accessLocation.cgi_id }).then(res => {
		if (res.data.data) {
			commit(types.DEL_LISTING, accessLocation);
		}
	});
}

export default {
	ActionListing,
	ActionRevoke,
}